module.exports = __webpack_public_path__ + "img/icon_ing3.53d2f2c.png";